/**
 * A aparência de cada coisa do mapa: o ícone do tipo de bloco, o grupo dele e a
 * cor de cada saída. O mapa, a paleta e a simulação usam os mesmos, para o
 * bloco e o passo da simulação serem reconhecidos um pelo outro.
 */

import type { NomeDoIcone } from '@/shared/ui';
import type { GrupoDoBloco } from './mapa';

/** O ícone de cada tipo de bloco, da família de ícones do produto. */
export const ICONE_DO_TIPO: Record<string, NomeDoIcone> = {
  comeco: 'automacao',
  acao: 'enviar',
  condicao: 'funil',
  escolha: 'menu',
  esperar_tempo: 'relogio',
  esperar_evento: 'sino',
  consulta_sql: 'documento',
  para_cada: 'repetir',
};

export function iconeDoTipo(tipo: string): NomeDoIcone {
  return ICONE_DO_TIPO[tipo] ?? 'automacao';
}

/**
 * O tipo do bloco de um passo simulado. O serviço manda, no passo de uma ação,
 * o nome da ação (`enviar_mensagem`) e não o tipo do bloco (`acao`): vale o
 * tipo do bloco no mapa, quando ele está lá, e uma ação do catálogo conta como
 * `acao`.
 */
export function tipoDoPasso(
  tipo: string,
  tipoNoMapa: string | undefined,
  acoesDoCatalogo: readonly string[],
): string {
  if (tipoNoMapa) return tipoNoMapa;
  return acoesDoCatalogo.includes(tipo) ? 'acao' : tipo;
}

/** O grupo de um tipo de bloco: dá a cor do bloco no mapa e na paleta. */
export function grupoDoTipo(tipo: string): GrupoDoBloco {
  if (tipo === 'comeco') return 'comeco';
  if (tipo === 'acao') return 'acao';
  if (tipo === 'condicao' || tipo === 'escolha') return 'logica';
  if (tipo.startsWith('esperar')) return 'espera';
  return 'dados';
}

export type TomDaSaida = 'padrao' | 'sim' | 'nao' | 'tempo' | 'caso';

/**
 * O tom de uma saída: o ponto no bloco e a cor da ligação que sai dela. Sim é
 * verde, não é vermelho, tempo esgotado é atenção, um caso da escolha é azul;
 * o "próximo" e o "outro caso" seguem o roxo suave.
 */
export function tomDaSaida(saida: string): TomDaSaida {
  if (saida === 'sim') return 'sim';
  if (saida === 'nao') return 'nao';
  if (saida === 'tempo_esgotado') return 'tempo';
  if (saida.startsWith('caso:')) return 'caso';
  return 'padrao';
}

export const COR_DO_TOM: Record<TomDaSaida, string> = {
  padrao: 'var(--roxo-suave)',
  sim: 'var(--ok)',
  nao: 'var(--erro)',
  tempo: 'var(--atencao)',
  caso: 'var(--info)',
};
